import React from "react";
import { Card, Table, Typography } from "antd";

const { Text } = Typography;

/**
 * ProductStockTable
 * @param {Array} productStock - Array of objects: [{ product, currentStock, lastRefreshDate }]
 */
const ProductStockTable = ({ productStock = [] }) => {
  const columns = [
    {
      title: "Product",
      dataIndex: "product_variation_code",
      key: "product_variation_code",
      align: "center",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Current Stock",
      dataIndex: "current_stock",
      key: "current_stock",
      align: "center",
      render: (value) => <Text strong>{Number(value).toLocaleString()}</Text>,
    },
    {
      title: "Last Refresh Date",
      dataIndex: "inventory_date",
      key: "inventory_date",
      align: "center",
      render: (date) => <Text type="secondary">{date}</Text>,
    },
  ];

  return (
    <Table
      bordered
      size="small"
      columns={columns}
      dataSource={productStock}
      rowKey={(row) => row.product_variation_code + row.inventory_date}
      pagination={false}
      className="small-font"
      scroll={{ x: "max-content" }}
      locale={{ emptyText: "No product stock data available" }}
    />
  );
};

export default ProductStockTable;
